/**
 * Ticket #91 — indicateur discret de chargement en arrière-plan. À placer dans
 * un parent `position: relative` : une barre de 2 px glisse en haut de celui-ci
 * sans décaler la mise en page (jamais d'overlay « Chargement… » pendant un
 * simple déplacement temporel).
 */
export default function TimelineProgress({ active }) {
  if (!active) return null;
  return <div className="timeline-progress" role="progressbar" aria-label="Chargement en cours" />;
}
